<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="xl"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >
            <template #modal-title>
                <div class="d-flex w-100 align-items-center">
                    Compare Unit To Trunk Unit: {{ unit_group.title }}
                </div>
            </template>
            <div v-if="comparison">

                <div class="alert alert-info">
                    <span
                        class="collapse-icon text-dark mr-1"
                        :class="show_week_level_diff ? null : 'collapsed'"
                        :aria-expanded="show_week_level_diff ? 'true' : 'false'"
                        @click="show_week_level_diff = !show_week_level_diff"
                    >
                        <span class="open">
                            <font-awesome-icon :icon="['fas', 'caret-down']" fixed-width />
                        </span>
                        <span class="closed">
                            <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width />
                        </span>
                        Unit Diffs
                    </span>
                </div>

                <div v-if="show_week_level_diff">
                    <div class="row mb-3">
                        <div class="col">
                            <div class="card">
                                <div class="card-header" style="height: 60px;">
                                    Branch Title:
                                    <b-btn
                                    v-if="!comparison.title_differences.title_matches"
                                        :class="comparison.accepted_updates.unit_group_updates.title == 1 ? 'float-right update-disabled' : 'float-right'"
                                        size="sm"
                                        :variant="'danger'"
                                        content="Update Unit Item to Trunk"
                                        v-tippy="{placement: 'top'}"
                                    >
                                        <div>
                                            <b-form-checkbox
                                                size="sm"
                                                :checked="unitDifferenceUpdate('title')"
                                                :disabled="comparison.accepted_updates.unit_group_updates.title == 1"
                                                @change="toggleUnitUpdateItem('title')"
                                                switch
                                            >
                                                Update
                                            </b-form-checkbox>

                                        </div>
                                    </b-btn>

                                    <b-btn
                                        v-if="!comparison.title_differences.title_matches"
                                        class="float-right mr-1"
                                        size="sm"
                                        :variant="'info'"
                                        content="Update Unit Item to Trunk"
                                        v-tippy="{placement: 'top'}"
                                    >
                                        <div>
                                            <b-form-checkbox
                                                size="sm"
                                                :checked="comparison.accepted_updates.unit_group_updates.title == 1"
                                                @change="ignoringUnitAcceptedItem('title')"
                                                switch
                                            >
                                                Ignore
                                            </b-form-checkbox>

                                        </div>
                                    </b-btn>

                                </div>
                                <div class="card-body">
                                    {{ comparison.title_differences.branch_title }}
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="card">
                                <div class="card-header" style="height: 60px;">Trunk Title:</div>
                                <div class="card-body">{{ comparison.title_differences.trunk_title }}</div>
                            </div>
                        </div>
                    </div>
                </div>

            <div class="alert alert-primary">
                <span
                    class="collapse-icon text-dark mr-1"
                    :class="show_article_level_diff ? null : 'collapsed'"
                    :aria-expanded="show_article_level_diff ? 'true' : 'false'"
                    @click="show_article_level_diff = !show_article_level_diff"
                >
                    <span class="open">
                        <font-awesome-icon :icon="['fas', 'caret-down']" fixed-width />
                    </span>
                    <span class="closed">
                        <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width />
                    </span>
                    Unit Assessment Diffs
                </span>
            </div>
            <div v-if="show_article_level_diff">
                <div class="alert alert-danger m-4">
                    <div class="h4">Please update minor question edits only. (ex. typos)</div>
                    <div>Major changes warrant a new question. (ex. meaning of question has changed or the correct answer option is wrong)</div>
                </div>
                <div class="row" v-for="(assessment_question, assessment_question_index) in comparison.assessment_questions_differences">
                    <div class="col">
                        <!-- {{ assessment_question }} -->
                        <hr/>
                        <div class="update-button-container row">
                            <b-btn
                                class="float-right update-button"
                                size="sm"
                                :variant="'info'"
                                content="Update Question to Trunk Versions"
                                v-tippy="{placement: 'top'}"
                                v-if="!assessment_question.matching"
                            >
                                <div>
                                    <b-form-checkbox
                                        size="sm"
                                        :checked="ignoringUnitGroupQuestionUpdate(assessment_question)"
                                        @change="toggleUnitQuestionIgnoreItem(assessment_question)"
                                        switch
                                    >
                                        Ignore
                                    </b-form-checkbox>
                                </div>
                            </b-btn>
                            <b-btn
                                :class="ignoringUnitGroupQuestionUpdate(assessment_question) ? 'float-right update-button update-disabled' : 'float-right update-button'"
                                size="sm"
                                :variant="'danger'"
                                content="Update Question to Trunk Versions"
                                v-tippy="{placement: 'top'}"
                                v-if="!assessment_question.matching"
                            >

                                <div>
                                    <b-form-checkbox
                                        size="sm"
                                        :disabled="ignoringUnitGroupQuestionUpdate(assessment_question)"
                                        @change="toggleUnitQuestionUpdateItem(assessment_question)"
                                        switch
                                    >
                                        Update
                                    </b-form-checkbox>
                                </div>
                            </b-btn>
                            <div class="alert question-id-alert small"> Parent ID: {{ assessment_question.trunk_question.id }}</div>
                        </div>
                        <div class="">
                            <question-content
                                :question="assessment_question.branch_question"
                            />
                        </div>
                    </div>
                    <div class="col">
                        <div>
                            <hr/>
                            <div class="row update-button-container">
                                <div v-if="assessment_question.trunk_question" class="alert question-id-alert small">Question ID: {{ assessment_question.trunk_question.id }}</div>
                                <div v-else class="alert question-id-alert small">No Trunk</div>
                            </div>

                            <question-content
                                :question="assessment_question.trunk_question"
                            />
                        </div>
                    </div>
                </div>
            </div>

            </div>
            <template #modal-footer>
                <b-button variant="primary" @click="saveAllSelectedUpdates">
                    Update
                </b-button>
                <b-button variant="light" @click="cancel">
                    Cancel
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

    .update-button{
        // margin-right: auto;
        max-height: 35px;
        min-height: 35px;
        margin-left: 5%;;
    }
    .update-button-container{
        min-height: 35px;;
    }
    .update-disabled{
        background-color: lightgrey;
    }
    .question-id-alert{
        // background-color: gray;
        border-color: black;
        color: black;
        max-height: 50px;
        min-height: 50px;
        padding-bottom: 20px;
        margin-left:auto;
        margin-right: 5%;;
    }

</style>

<script>

// import Vue from 'vue'
import { mapState } from 'vuex'
import TipTap from '@/components/tiptap/TipTap'
import QuestionContent from '@/components/questions/Index'

export default {
    data: () => ({
       unit_updates: [],
       articles_to_update: [],
       article_questions_to_update: [],
       unit_group_questions_to_update: [],
       trunk_article_to_add: [],
       show_week_level_diff: false,
       show_week_assessment_diff: false,
       show_article_level_diff: false,
       show_trunk_only_articles: false,
       show_branch_only_articles: false,
    }),
    props: [
        'value',
        'comparison',
        'publication',
        'unit_group'
    ],
    components: {
        TipTap,
        QuestionContent,
    },
    computed: {
        ...mapState({

        }),
        modal_id () {
            let modal_id = null

            if (this.unit_group.id) {
                modal_id = 'trunk-comparison-modal' + this.unit_group.id
            }

            return modal_id
        }
    },
    methods: {
        UpdateArticleToTrunk(branch_article, trunk_article){
            let search_for = {
                branch_article_id: branch_article.id,
                trunk_article_id: branch_article.parent_article_id
            };
            let article_index = this.articleDifferenceUpdate(branch_article);
            if (article_index !== -1) {
                this.articles_to_update.splice(article_index, 1);
            }
            else{
                this.articles_to_update.push(search_for);
            }
        },
        articleDifferenceUpdate(branch_article){
            let status = -1;
            _.each( this.articles_to_update, function( article_data, diff_index ){
                // updates.push(diff.difference);
                if(article_data.branch_article_id == branch_article.id){
                    status = diff_index;
                }
            });
            return status;
        },
        selectAllUnitUpdates(){
            this.unit_updates = [];
            let updates = [];
            _.each( this.comparison.unit_differences, function( diff, diff_index ){
                updates.push(diff.difference);
            });
            this.unit_updates = updates;
        },
        toggleUnitUpdateItem(difference_field){
            const index = this.unit_updates.indexOf(difference_field);
            if (index !== -1) {
                this.unit_updates.splice(index, 1);
            }
            else{
                this.unit_updates.push(difference_field);
            }
        },


        unitDifferenceUpdate(difference_field){
            const found = this.unit_updates.find(item => item === difference_field);
            if (found) {
                return true;
            } else {
                return false;
            }
        },
        articleQuestionDifferenceUpdate(branch_question){
            let status = -1;
            _.each( this.article_questions_to_update, function( article_question_data, diff_index ){
                if(article_question_data.id == branch_question.id){
                    status = diff_index;
                }
            });
            return status;
        },
        toggleArticleQuestionUpdateItem(branch_question){
            let search_for = {
                id: branch_question.id,
                parent_question_id: branch_question.parent_question_id,
                article_id: branch_question.pivot.article_id
            };
            let article_question_index = this.articleQuestionDifferenceUpdate(branch_question);
            if (article_question_index !== -1) {
                this.article_questions_to_update.splice(article_question_index, 1);
            }
            else{
                this.article_questions_to_update.push(search_for);
            }
        },
        toggleArticleIgnoreUpdateItem(article_id){
            if(this.comparison.accepted_updates.unit_articles_accepted.includes(article_id)){
                // Find the index of the integer to remove
                let indexToRemove = this.comparison.accepted_updates.unit_articles_accepted.indexOf(article_id);
                this.comparison.accepted_updates.unit_articles_accepted.splice(indexToRemove, 1);
            }
            else{
                this.comparison.accepted_updates.unit_articles_accepted.push(article_id);
            }
        },
        ignoringUnitAcceptedItem(difference_field){
            let new_status = 0;

            if(difference_field == 'title'){
                if(this.comparison.accepted_updates.unit_group_updates.title == 1){
                    this.comparison.accepted_updates.unit_group_updates.title = 0;
                }
                else{
                    this.comparison.accepted_updates.unit_group_updates.title = 1;
                    new_status = 1;
                }
            }
            else{
                if(this.comparison.accepted_updates.unit_group_updates.teacher_edition_title == 1){
                    this.comparison.accepted_updates.unit_group_updates.teacher_edition_title = 0;
                }
                else{
                    this.comparison.accepted_updates.unit_group_updates.teacher_edition_title = 1;
                    new_status = 1;
                }
            }

            this.axios.post('/api/unit_groups/toggle_unit_group_level_difference_acceptance/' + this.unit_group.id + '/' + difference_field + '/' + new_status)
            .then(response => {
                console.log(response.data);
            })
            .catch(error => {

            })
        },
        ignoringArticleUpdate(article_id){
            return this.comparison.accepted_updates.unit_articles_accepted.includes(article_id);
        },
        toggleArticleQuestionIgnoreUpdateItem(article_id, question_id){
            if(this.comparison.accepted_updates.unit_article_questions_accepted[article_id].includes(question_id)){
                // Find the index of the integer to remove
                let indexToRemove = this.comparison.accepted_updates.unit_article_questions_accepted[article_id].indexOf(question_id);
                this.comparison.accepted_updates.unit_article_questions_accepted[article_id].splice(indexToRemove, 1);
            }
            else{
                this.comparison.accepted_updates.unit_article_questions_accepted[article_id].push(question_id);
            }

        },
        ignoringArticleQuestionUpdate(article_id, question_id){
            return this.comparison.accepted_updates.unit_article_questions_accepted[article_id] && this.comparison.accepted_updates.unit_article_questions_accepted[article_id].includes(question_id);
        },
        toggleUnitQuestionIgnoreItem(assessment_question){
            var new_status = !this.ignoringUnitGroupQuestionUpdate(assessment_question);
            this.axios.post('/api/unit_groups/toggle_unit_group_question_difference_acceptance/' + this.unit_group.id + '/' + assessment_question.branch_question.id + '/' + new_status)
            .then(response => {
                console.log(response.data.unit_group_question_updates);
                this.comparison.accepted_updates.unit_group_question_updates = response.data.unit_group_question_updates;

            })
            .catch(error => {

            })
        },
        ignoringUnitGroupQuestionUpdate(question){
            return this.comparison.accepted_updates.unit_group_question_updates.includes(question.branch_question.id);
        },
        unitQuestionDifferenceUpdate(branch_question){
            let status = -1;
            _.each( this.unit_group_questions_to_update, function( unit_question_data, diff_index ){
                if(unit_question_data.id == branch_question.id){
                    status = diff_index;
                }
            });
            return status;
        },
        toggleUnitQuestionUpdateItem(assessment_question){
            let search_for = {
                id: assessment_question.branch_question.id,
                parent_question_id: assessment_question.trunk_question.id
            };
            let unit_question_index = this.unitQuestionDifferenceUpdate(assessment_question.branch_question);

            if (unit_question_index !== -1) {
                this.unit_group_questions_to_update.splice(unit_question_index, 1);
            }
            else{
                this.unit_group_questions_to_update.push(search_for);
            }
        },
        unitTrunkOnlyArticleUpdate(trunk_article){
            let status = -1;
            _.each( this.trunk_article_to_add, function( trunk_article_data, trunk_article_diff_index ){
                if(trunk_article_data.trunk_article_id == trunk_article.id){
                    status = trunk_article_diff_index;
                }
            });
            return status;
        },
        toggleTrunkOnlyArticleUpdateItem(trunk_article){
            console.log(trunk_article, this.unit.id);
            let search_for = {
                trunk_article_id: trunk_article.id,
                trunk_article_page: trunk_article.page,
                branch_unit_id: this.unit.id,
                branch_publication_id: this.unit.publication_id,
                trunk_publication_id: this.unit.trunks[0].trunk_publication_id
            };
            let trunk_article_index = this.unitTrunkOnlyArticleUpdate(trunk_article);

            if (trunk_article_index !== -1) {
                this.trunk_article_to_add.splice(trunk_article_index, 1);
            }
            else{
                this.trunk_article_to_add.push(search_for);
            }
        },
        saveAllSelectedUpdates(){
            if(this.article_questions_to_update.length > 0 || this.unit_group_questions_to_update.length > 0){
                this.$swal({
                    html: 'Please confirm that question updates do not include major changes?',
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    confirmButtonColor: '#E67E22',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.axios.post('/api/unit_groups/update_branch_elements_to_trunk/' + this.unit_group.id, {
                            unit_updates: this.unit_updates,
                            article_updates: this.articles_to_update,
                            article_questions_to_update: this.article_questions_to_update,
                            unit_group_questions_to_update: this.unit_group_questions_to_update,
                            trunk_article_to_add: this.trunk_article_to_add,
                            accepted_updates: this.comparison.accepted_updates
                        })
                        .then(response => {
                            this.resetModal();
                            this.$emit('refreshUnit');
                        })
                        .catch(error => {

                        });
                    }
                })
            }
            else{
                this.axios.post('/api/unit_groups/update_branch_elements_to_trunk/' + this.unit_group.id, {
                    unit_updates: this.unit_updates,
                    article_updates: this.articles_to_update,
                    article_questions_to_update: this.article_questions_to_update,
                    unit_group_questions_to_update: this.unit_group_questions_to_update,
                    trunk_article_to_add: this.trunk_article_to_add,
                    accepted_updates: this.comparison.accepted_updates
                })
                .then(response => {
                    this.resetModal();
                    this.$emit('refreshUnit');
                })
                .catch(error => {

                });
            }

        },
        resetModal(){
            this.unit_updates = [];
            this.articles_to_update = [];
            this.article_questions_to_update =[];
            this.unit_group_questions_to_update =[];
            this.trunk_article_to_add = [];
            this.show_week_level_diff = false;
            this.show_week_assessment_diff = false;
            this.show_article_level_diff = false;
            this.show_trunk_only_articles = false;
            this.show_branch_only_articles = false;
        },
        cancel (event) {
            event.preventDefault()
            this.hide()
        },
        hide() {
            this.resetModal();
            this.$emit('hide')
        },
        hidden () {
            this.resetModal();
            this.$emit('hide')
        }
    }
}
</script>
